//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import ITokenProvider from "../../node_modules/arc4u.framework.js/token/ITokenProvider";
import TokenProviderFactory from "../../node_modules/arc4u.framework.js/token/TokenProviderFactory";
import { getChoosenLanguage } from '@/lib/locale';
import { registerForm } from '@/fixtures/register';
export class OAuthBase {
    protected transformOptions(options: RequestInit): Promise<RequestInit> {
        return new Promise<RequestInit>((resolve, reject) => {
            const choosenLanguage = getChoosenLanguage();
            if(choosenLanguage) options.headers = { ...options.headers, 'Accept-Language' : choosenLanguage }
            if(registerForm.recaptchaToken && registerForm.recaptchaToken !== '') options.headers = { ...options.headers, 'g-recaptcha-token': registerForm.recaptchaToken }
            resolve(options);
        });
    }
}

export class CandidateClient extends OAuthBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets information for all the known candidates.
     * @param nameLike (optional) 
     * @param countryLike (optional) 
     * @return The collection of known candidates.
     */
    getCandidates(nameLike?: string | null | undefined, countryLike?: string | null | undefined): Promise<Candidate[]> {
        let url_ = this.baseUrl + "/candidatemgt/facade/candidate?";
        if (nameLike !== undefined && nameLike !== null)
            url_ += "NameLike=" + encodeURIComponent("" + nameLike) + "&";
        if (countryLike !== undefined && countryLike !== null)
            url_ += "CountryLike=" + encodeURIComponent("" + countryLike) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCandidates(_response);
        });
    }

    protected processGetCandidates(response: Response): Promise<Candidate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Candidate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Candidate[]>(null as any);
    }

    /**
     * Gets information about the candidate behind the authenticated user.
     * @return The requested candidate information.
     */
    getByPrincipal(): Promise<Candidate> {
        let url_ = this.baseUrl + "/candidatemgt/facade/candidate/current";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByPrincipal(_response);
        });
    }

    protected processGetByPrincipal(response: Response): Promise<Candidate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Candidate.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Candidate>(null as any);
    }

    /**
     * Gets information about a specific candidate.
     * @return The requested candidate information.
     */
    getById(candidateId: string): Promise<Candidate> {
        let url_ = this.baseUrl + "/candidatemgt/facade/candidate/{candidateId}";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined.");
        url_ = url_.replace("{candidateId}", encodeURIComponent("" + candidateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<Candidate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Candidate.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Candidate>(null as any);
    }

    /**
     * Update a candidate.
     * @param candidateId The candidate's Id.
     * @param candidate The candidate.
     * @return A value indicating the result of the operation.
     */
    updateCandidate(candidateId: string, candidate: Candidate): Promise<Candidate> {
        let url_ = this.baseUrl + "/candidatemgt/facade/candidate/{candidateId}";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined.");
        url_ = url_.replace("{candidateId}", encodeURIComponent("" + candidateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(candidate);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCandidate(_response);
        });
    }

    protected processUpdateCandidate(response: Response): Promise<Candidate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Candidate.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Candidate>(null as any);
    }

    /**
     * Delete specific candidate.
     * @return The result of the operation.
     */
    delete(candidateId: string): Promise<void> {
        let url_ = this.baseUrl + "/candidatemgt/facade/candidate/{candidateId}";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined.");
        url_ = url_.replace("{candidateId}", encodeURIComponent("" + candidateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update a candidate based on CC data.
     * @param candidateId The candidate to update.
     * @return A bolean true if data has been updated, false if there was no difference between cc and db.
     */
    updateCandidateWithCC(candidateId: string): Promise<boolean> {
        let url_ = this.baseUrl + "/candidatemgt/facade/candidate/{candidateId}/cc";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined.");
        url_ = url_.replace("{candidateId}", encodeURIComponent("" + candidateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCandidateWithCC(_response);
        });
    }

    protected processUpdateCandidateWithCC(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Update the state of the application form for the given candidate.
     * @param candidateId The candidate unique identifier.
     * @param state The request containing the information to be used for updating the candidate.
     * @return An object containing the candidate unique identifier.
     */
    updateCandidateState(candidateId: string, state: CandidateRequestStatus): Promise<void> {
        let url_ = this.baseUrl + "/candidatemgt/facade/candidate/{candidateId}/state";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined.");
        url_ = url_.replace("{candidateId}", encodeURIComponent("" + candidateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(state);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCandidateState(_response);
        });
    }

    protected processUpdateCandidateState(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CandidateRegistrationClient extends OAuthBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Adds a new candidate.
     * @param newCandidate The model containing the information to be used for creating the candidate.
     */
    addCandidate(newCandidate: NewCandidate): Promise<Candidate> {
        let url_ = this.baseUrl + "/candidatemgt/facade/candidateregistration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newCandidate);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddCandidate(_response);
        });
    }

    protected processAddCandidate(response: Response): Promise<Candidate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Candidate.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Candidate>(null as any);
    }

    /**
     * Get the disclaimer.
     * @return The disclaimer.
     */
    getDisclaimer(): Promise<string> {
        let url_ = this.baseUrl + "/candidatemgt/facade/candidateregistration/disclaimer";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDisclaimer(_response);
        });
    }

    protected processGetDisclaimer(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class CompetenceClient extends OAuthBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets information for the competences covered by the contacts for a candidate.
     * @return The collection of competences.
     */
    getCompetences(candidateId: string): Promise<string[]> {
        let url_ = this.baseUrl + "/candidatemgt/facade/candidate/{candidateId}/competence";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined.");
        url_ = url_.replace("{candidateId}", encodeURIComponent("" + candidateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompetences(_response);
        });
    }

    protected processGetCompetences(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class ContactClient extends OAuthBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Update a contact for a candidate.
     * @param candidateId The candidate unique identifier.
     * @param contact The contact information.
     * @return A value indicating the result of the operation.
     */
    updateContact(candidateId: string, contact: Contact): Promise<Contact> {
        let url_ = this.baseUrl + "/candidatemgt/facade/candidate/{candidateId}/contact";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined.");
        url_ = url_.replace("{candidateId}", encodeURIComponent("" + candidateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contact);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateContact(_response);
        });
    }

    protected processUpdateContact(response: Response): Promise<Contact> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Contact.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Contact>(null as any);
    }

    /**
     * Create a contact for a candidate having the technical role B2B technical user
     * @param candidateId The id of the candidate
     * @param email (optional) The email of user
     */
    createB2BTechnicalUser(candidateId: string, email?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/candidatemgt/facade/candidate/{candidateId}/contact/CreateB2BTechnicalUser?";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined.");
        url_ = url_.replace("{candidateId}", encodeURIComponent("" + candidateId));
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateB2BTechnicalUser(_response);
        });
    }

    protected processCreateB2BTechnicalUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class EnvironmentClient extends OAuthBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Return details information about the application.
     * @return Return the environment information.
     */
    get(): Promise<EnvironmentInfo | null> {
        let url_ = this.baseUrl + "/CandidateMgt/facade/Environment";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<EnvironmentInfo | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(Message.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("Error during the process of the request.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EnvironmentInfo.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnvironmentInfo | null>(null as any);
    }
}

export class InfraClient extends OAuthBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets information for all the known countries.
     * @return The collection of known countries.
     */
    getCountries(): Promise<Country[]> {
        let url_ = this.baseUrl + "/candidatemgt/facade/infra/country";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCountries(_response);
        });
    }

    protected processGetCountries(response: Response): Promise<Country[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Country.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Country[]>(null as any);
    }

    /**
     * Gets information for all the known competences.
     * @return The collection of known competences.
     */
    getCompetences(): Promise<Competence[]> {
        let url_ = this.baseUrl + "/candidatemgt/facade/infra/competence";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompetences(_response);
        });
    }

    protected processGetCompetences(response: Response): Promise<Competence[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Competence.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Competence[]>(null as any);
    }

    /**
     * Gets information for all the known languages.
     * @return The collection of known languages.
     */
    getLanguages(): Promise<Language[]> {
        let url_ = this.baseUrl + "/candidatemgt/facade/infra/language";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLanguages(_response);
        });
    }

    protected processGetLanguages(response: Response): Promise<Language[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Language.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Language[]>(null as any);
    }

    /**
     * Gets information for all the known languages.
     * @return The collection of known languages.
     */
    getCurrencies(): Promise<Currency[]> {
        let url_ = this.baseUrl + "/candidatemgt/facade/infra/currency";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrencies(_response);
        });
    }

    protected processGetCurrencies(response: Response): Promise<Currency[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Currency.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Currency[]>(null as any);
    }

    /**
     * Gets information for all the known person titles.
     * @return The collection of known person titles.
     */
    getPersonTitles(): Promise<PersonTitle[]> {
        let url_ = this.baseUrl + "/candidatemgt/facade/infra/titles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPersonTitles(_response);
        });
    }

    protected processGetPersonTitles(response: Response): Promise<PersonTitle[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonTitle.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonTitle[]>(null as any);
    }

    /**
     * Gets information for all the known legal status.
     * @return The collection of known legal status.
     */
    getLegalStatus(): Promise<LegalStatus[]> {
        let url_ = this.baseUrl + "/candidatemgt/facade/infra/legalstatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLegalStatus(_response);
        });
    }

    protected processGetLegalStatus(response: Response): Promise<LegalStatus[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LegalStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LegalStatus[]>(null as any);
    }

    /**
     * Gets information for the known legal status by country.
     * @return The collection of known legal status.
     */
    getLegalStatusByCountryId(countryId: string): Promise<LegalStatus[]> {
        let url_ = this.baseUrl + "/candidatemgt/facade/infra/legalstatusByCountry/{countryId}";
        if (countryId === undefined || countryId === null)
            throw new Error("The parameter 'countryId' must be defined.");
        url_ = url_.replace("{countryId}", encodeURIComponent("" + countryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLegalStatusByCountryId(_response);
        });
    }

    protected processGetLegalStatusByCountryId(response: Response): Promise<LegalStatus[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LegalStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LegalStatus[]>(null as any);
    }

    /**
     * Gets the available derating factor options.
     * @return The available derating factor options.
     */
    getRoles(): Promise<Option[]> {
        let url_ = this.baseUrl + "/candidatemgt/facade/infra/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: Response): Promise<Option[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Option.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Option[]>(null as any);
    }

    /**
     * Gets the available derating factor options.
     * @return The available derating factor options.
     */
    getMailingOptions(): Promise<MailingOptions> {
        let url_ = this.baseUrl + "/candidatemgt/facade/infra/mailoptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMailingOptions(_response);
        });
    }

    protected processGetMailingOptions(response: Response): Promise<MailingOptions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MailingOptions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MailingOptions>(null as any);
    }
}

export class MailSenderClient extends OAuthBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Sends multiple email message related to a candidate.
     * @param emailMessages The email messages.
     */
    sendEmail(emailMessages: EmailMessage[]): Promise<void> {
        let url_ = this.baseUrl + "/candidatemgt/facade/candidate/mailsender/send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailMessages);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendEmail(_response);
        });
    }

    protected processSendEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Sends multiple email message related to a candidate.
     * @param emailMessages The email messages.
     */
    resendEmail(emailMessages: EmailMessage[]): Promise<void> {
        let url_ = this.baseUrl + "/candidatemgt/facade/candidate/mailsender/resend";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailMessages);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResendEmail(_response);
        });
    }

    protected processResendEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SettingClient extends OAuthBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets the settings.
     * @return The settings.
     */
    getSettings(): Promise<Setting[]> {
        let url_ = this.baseUrl + "/candidatemgt/facade/setting";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSettings(_response);
        });
    }

    protected processGetSettings(response: Response): Promise<Setting[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Setting.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Setting[]>(null as any);
    }

    /**
     * Update the settings.
     * @param settings The settings to update.
     * @return OK if success.
     */
    updateSettings(settings: Setting[]): Promise<void> {
        let url_ = this.baseUrl + "/candidatemgt/facade/setting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSettings(_response);
        });
    }

    protected processUpdateSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the validators.
     * @return The validators.
     */
    getValidators(): Promise<Validator[]> {
        let url_ = this.baseUrl + "/candidatemgt/facade/setting/validators";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetValidators(_response);
        });
    }

    protected processGetValidators(response: Response): Promise<Validator[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Validator.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Validator[]>(null as any);
    }

    /**
     * Update the validators.
     * @param validators The validators to update.
     * @return OK if success.
     */
    updateValidators(validators: Validator[]): Promise<void> {
        let url_ = this.baseUrl + "/candidatemgt/facade/setting/validators";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(validators);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateValidators(_response);
        });
    }

    protected processUpdateValidators(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

/** Represents a candidate. */
export class Candidate implements ICandidate {
    /** The unique identifier of the candidate. */
    id?: string | undefined;
    /** The date on which the candidate was created. */
    createdOn?: Date;
    /** The date on which the candidate was updated. */
    updatedOn?: Date;
    /** The company business number. */
    businessNumber?: string | undefined;
    /** The company name. */
    name?: string | undefined;
    /** The code identifying the legal status of the company. */
    legalStatus?: string | undefined;
    /** The company phone number. */
    phone?: string | undefined;
    /** The company fax number. */
    fax?: string | undefined;
    /** The company vat number. */
    registrationNumber?: string | undefined;
    /** The street name. */
    street?: string | undefined;
    /** The street number. */
    number?: string | undefined;
    /** The zip code. */
    postalCode?: string | undefined;
    /** The city name. */
    city?: string | undefined;
    /** The country code name. */
    country?: string | undefined;
    /** The company contacts information. */
    contacts?: Contact[] | undefined;
    /** The company application status. */
    applicationStatus?: ApplicationStatus;
    /** The value indicating whether the company vat number is valid. */
    registrationNumberIsValid?: boolean;
    /** The value indicating whether the company submission is valid. */
    isValid?: boolean;
    /** The value indicating whether the candidate is compliant to the legal agreements related to standard and specific. */
    isCompliant?: boolean | undefined;
    /** The value indicating whether the candidate is compliant to the legal agreements related to fast-track. */
    isCompliantFastTrack?: boolean | undefined;
    /** The value indicating whether the candidate is compliant to the legal agreements related to light pq Files */
    isCompliantLPQ?: boolean | undefined;
    /** The date indicating when the application form has been submitted. */
    submittedOn?: Date;
    /** The date indicating when the application form has been submitted for approval. */
    approvalRequestedOn?: Date | undefined;
    /** The date indicating when the application form has been approved. */
    approvedOn?: Date | undefined;
    /** The date indicating when the application form has been rejected. */
    rejectedOn?: Date | undefined;
    /** The reason why the application form has been rejected or approved. */
    commentToCandidate?: string | undefined;
    /** The number of properties that have been updated after the CC call. */
    ccUpdatedProperties?: number;
    /** The value indicating whether the candidate data is different from what is in CC. */
    hasDifferenceWithCC?: boolean | undefined;
    /** The Elia validation team. */
    eliaValidationTeam?: EliaValidationTeam | undefined;

    constructor(data?: ICandidate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.businessNumber = _data["businessNumber"];
            this.name = _data["name"];
            this.legalStatus = _data["legalStatus"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            this.registrationNumber = _data["registrationNumber"];
            this.street = _data["street"];
            this.number = _data["number"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.country = _data["country"];
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(Contact.fromJS(item));
            }
            this.applicationStatus = _data["applicationStatus"];
            this.registrationNumberIsValid = _data["registrationNumberIsValid"];
            this.isValid = _data["isValid"];
            this.isCompliant = _data["isCompliant"];
            this.isCompliantFastTrack = _data["isCompliantFastTrack"];
            this.isCompliantLPQ = _data["isCompliantLPQ"];
            this.submittedOn = _data["submittedOn"] ? new Date(_data["submittedOn"].toString()) : <any>undefined;
            this.approvalRequestedOn = _data["approvalRequestedOn"] ? new Date(_data["approvalRequestedOn"].toString()) : <any>undefined;
            this.approvedOn = _data["approvedOn"] ? new Date(_data["approvedOn"].toString()) : <any>undefined;
            this.rejectedOn = _data["rejectedOn"] ? new Date(_data["rejectedOn"].toString()) : <any>undefined;
            this.commentToCandidate = _data["commentToCandidate"];
            this.ccUpdatedProperties = _data["ccUpdatedProperties"];
            this.hasDifferenceWithCC = _data["hasDifferenceWithCC"];
            this.eliaValidationTeam = _data["eliaValidationTeam"] ? EliaValidationTeam.fromJS(_data["eliaValidationTeam"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Candidate {
        data = typeof data === 'object' ? data : {};
        let result = new Candidate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["businessNumber"] = this.businessNumber;
        data["name"] = this.name;
        data["legalStatus"] = this.legalStatus;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["registrationNumber"] = this.registrationNumber;
        data["street"] = this.street;
        data["number"] = this.number;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["country"] = this.country;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        data["applicationStatus"] = this.applicationStatus;
        data["registrationNumberIsValid"] = this.registrationNumberIsValid;
        data["isValid"] = this.isValid;
        data["isCompliant"] = this.isCompliant;
        data["isCompliantFastTrack"] = this.isCompliantFastTrack;
        data["isCompliantLPQ"] = this.isCompliantLPQ;
        data["submittedOn"] = this.submittedOn ? this.submittedOn.toISOString() : <any>undefined;
        data["approvalRequestedOn"] = this.approvalRequestedOn ? this.approvalRequestedOn.toISOString() : <any>undefined;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : <any>undefined;
        data["rejectedOn"] = this.rejectedOn ? this.rejectedOn.toISOString() : <any>undefined;
        data["commentToCandidate"] = this.commentToCandidate;
        data["ccUpdatedProperties"] = this.ccUpdatedProperties;
        data["hasDifferenceWithCC"] = this.hasDifferenceWithCC;
        data["eliaValidationTeam"] = this.eliaValidationTeam ? this.eliaValidationTeam.toJSON() : <any>undefined;
        return data;
    }
}

/** Represents a candidate. */
export interface ICandidate {
    /** The unique identifier of the candidate. */
    id?: string | undefined;
    /** The date on which the candidate was created. */
    createdOn?: Date;
    /** The date on which the candidate was updated. */
    updatedOn?: Date;
    /** The company business number. */
    businessNumber?: string | undefined;
    /** The company name. */
    name?: string | undefined;
    /** The code identifying the legal status of the company. */
    legalStatus?: string | undefined;
    /** The company phone number. */
    phone?: string | undefined;
    /** The company fax number. */
    fax?: string | undefined;
    /** The company vat number. */
    registrationNumber?: string | undefined;
    /** The street name. */
    street?: string | undefined;
    /** The street number. */
    number?: string | undefined;
    /** The zip code. */
    postalCode?: string | undefined;
    /** The city name. */
    city?: string | undefined;
    /** The country code name. */
    country?: string | undefined;
    /** The company contacts information. */
    contacts?: Contact[] | undefined;
    /** The company application status. */
    applicationStatus?: ApplicationStatus;
    /** The value indicating whether the company vat number is valid. */
    registrationNumberIsValid?: boolean;
    /** The value indicating whether the company submission is valid. */
    isValid?: boolean;
    /** The value indicating whether the candidate is compliant to the legal agreements related to standard and specific. */
    isCompliant?: boolean | undefined;
    /** The value indicating whether the candidate is compliant to the legal agreements related to fast-track. */
    isCompliantFastTrack?: boolean | undefined;
    /** The value indicating whether the candidate is compliant to the legal agreements related to light pq Files */
    isCompliantLPQ?: boolean | undefined;
    /** The date indicating when the application form has been submitted. */
    submittedOn?: Date;
    /** The date indicating when the application form has been submitted for approval. */
    approvalRequestedOn?: Date | undefined;
    /** The date indicating when the application form has been approved. */
    approvedOn?: Date | undefined;
    /** The date indicating when the application form has been rejected. */
    rejectedOn?: Date | undefined;
    /** The reason why the application form has been rejected or approved. */
    commentToCandidate?: string | undefined;
    /** The number of properties that have been updated after the CC call. */
    ccUpdatedProperties?: number;
    /** The value indicating whether the candidate data is different from what is in CC. */
    hasDifferenceWithCC?: boolean | undefined;
    /** The Elia validation team. */
    eliaValidationTeam?: EliaValidationTeam | undefined;
}

/** Represents a contact. */
export class Contact implements IContact {
    /** The contact language. */
    id?: string | undefined;
    /** The contact language. */
    language?: string | undefined;
    /** The contact gender. */
    civilStatus?: string | undefined;
    /** The contact login account. */
    login?: string | undefined;
    /** The contact first name. */
    firstName?: string | undefined;
    /** The contact last name. */
    lastName?: string | undefined;
    /** The contact function name. */
    function?: string | undefined;
    /** The contact fixed phone number. */
    phone?: string | undefined;
    /** The contact mobile phone number. */
    mobile?: string | undefined;
    /** The contact mobile phone number. */
    email?: string | undefined;
    /** The contact competences. */
    competences?: string[] | undefined;
    /** The roles for the contact. */
    roles?: string[] | undefined;

    constructor(data?: IContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.language = _data["language"];
            this.civilStatus = _data["civilStatus"];
            this.login = _data["login"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.function = _data["function"];
            this.phone = _data["phone"];
            this.mobile = _data["mobile"];
            this.email = _data["email"];
            if (Array.isArray(_data["competences"])) {
                this.competences = [] as any;
                for (let item of _data["competences"])
                    this.competences!.push(item);
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["language"] = this.language;
        data["civilStatus"] = this.civilStatus;
        data["login"] = this.login;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["function"] = this.function;
        data["phone"] = this.phone;
        data["mobile"] = this.mobile;
        data["email"] = this.email;
        if (Array.isArray(this.competences)) {
            data["competences"] = [];
            for (let item of this.competences)
                data["competences"].push(item);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

/** Represents a contact. */
export interface IContact {
    /** The contact language. */
    id?: string | undefined;
    /** The contact language. */
    language?: string | undefined;
    /** The contact gender. */
    civilStatus?: string | undefined;
    /** The contact login account. */
    login?: string | undefined;
    /** The contact first name. */
    firstName?: string | undefined;
    /** The contact last name. */
    lastName?: string | undefined;
    /** The contact function name. */
    function?: string | undefined;
    /** The contact fixed phone number. */
    phone?: string | undefined;
    /** The contact mobile phone number. */
    mobile?: string | undefined;
    /** The contact mobile phone number. */
    email?: string | undefined;
    /** The contact competences. */
    competences?: string[] | undefined;
    /** The roles for the contact. */
    roles?: string[] | undefined;
}

export enum ApplicationStatus {
    None = "None",
    Submitted = "Submitted",
    SubmittedWithErrors = "SubmittedWithErrors",
    Approved = "Approved",
    Rejected = "Rejected",
    SubmittedForApproval = "SubmittedForApproval",
    ApprovalFailed = "ApprovalFailed",
}

export class EliaValidationTeam implements IEliaValidationTeam {
    validator1?: string | undefined;
    validator1ValidationOn?: Date | undefined;
    validator1Results?: CandidateApplicationStatus | undefined;
    validator1ResultChangedBy?: string | undefined;
    commentValidator1?: string | undefined;
    validator2?: string | undefined;
    validator2Results?: CandidateApplicationStatus | undefined;
    validator2ValidationOn?: Date | undefined;
    validator2ResultChangedBy?: string | undefined;
    commentValidator2?: string | undefined;

    constructor(data?: IEliaValidationTeam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validator1 = _data["validator1"];
            this.validator1ValidationOn = _data["validator1ValidationOn"] ? new Date(_data["validator1ValidationOn"].toString()) : <any>undefined;
            this.validator1Results = _data["validator1Results"];
            this.validator1ResultChangedBy = _data["validator1ResultChangedBy"];
            this.commentValidator1 = _data["commentValidator1"];
            this.validator2 = _data["validator2"];
            this.validator2Results = _data["validator2Results"];
            this.validator2ValidationOn = _data["validator2ValidationOn"] ? new Date(_data["validator2ValidationOn"].toString()) : <any>undefined;
            this.validator2ResultChangedBy = _data["validator2ResultChangedBy"];
            this.commentValidator2 = _data["commentValidator2"];
        }
    }

    static fromJS(data: any): EliaValidationTeam {
        data = typeof data === 'object' ? data : {};
        let result = new EliaValidationTeam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validator1"] = this.validator1;
        data["validator1ValidationOn"] = this.validator1ValidationOn ? this.validator1ValidationOn.toISOString() : <any>undefined;
        data["validator1Results"] = this.validator1Results;
        data["validator1ResultChangedBy"] = this.validator1ResultChangedBy;
        data["commentValidator1"] = this.commentValidator1;
        data["validator2"] = this.validator2;
        data["validator2Results"] = this.validator2Results;
        data["validator2ValidationOn"] = this.validator2ValidationOn ? this.validator2ValidationOn.toISOString() : <any>undefined;
        data["validator2ResultChangedBy"] = this.validator2ResultChangedBy;
        data["commentValidator2"] = this.commentValidator2;
        return data;
    }
}

export interface IEliaValidationTeam {
    validator1?: string | undefined;
    validator1ValidationOn?: Date | undefined;
    validator1Results?: CandidateApplicationStatus | undefined;
    validator1ResultChangedBy?: string | undefined;
    commentValidator1?: string | undefined;
    validator2?: string | undefined;
    validator2Results?: CandidateApplicationStatus | undefined;
    validator2ValidationOn?: Date | undefined;
    validator2ResultChangedBy?: string | undefined;
    commentValidator2?: string | undefined;
}

export enum CandidateApplicationStatus {
    Approved = "Approved",
    Rejected = "Rejected",
}

export class CandidateRequestStatus implements ICandidateRequestStatus {
    applicationStatus?: CandidateApplicationStatus;
    commentToCandidate?: string | undefined;

    constructor(data?: ICandidateRequestStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationStatus = _data["applicationStatus"];
            this.commentToCandidate = _data["commentToCandidate"];
        }
    }

    static fromJS(data: any): CandidateRequestStatus {
        data = typeof data === 'object' ? data : {};
        let result = new CandidateRequestStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationStatus"] = this.applicationStatus;
        data["commentToCandidate"] = this.commentToCandidate;
        return data;
    }
}

export interface ICandidateRequestStatus {
    applicationStatus?: CandidateApplicationStatus;
    commentToCandidate?: string | undefined;
}

/** Represents a new candidate. */
export class NewCandidate implements INewCandidate {
    /** The creation date. */
    createdOn?: Date;
    /** The company business number. */
    businessNumber?: string | undefined;
    /** The company name. */
    name?: string | undefined;
    /** The company invoice name. */
    invoiceName?: string | undefined;
    /** The company phone number. */
    phone?: string | undefined;
    /** The company fax number. */
    fax?: string | undefined;
    /** The company vat number. */
    registrationNumber?: string | undefined;
    /** The street name. */
    street?: string | undefined;
    /** The street number. */
    number?: string | undefined;
    /** The zip code. */
    postalCode?: string | undefined;
    /** The city name. */
    city?: string | undefined;
    /** The country code name. */
    country?: string | undefined;
    /** The legal status. */
    legalStatus?: string | undefined;
    /** The company contacts information. */
    contacts?: Contact[] | undefined;

    constructor(data?: INewCandidate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.businessNumber = _data["businessNumber"];
            this.name = _data["name"];
            this.invoiceName = _data["invoiceName"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            this.registrationNumber = _data["registrationNumber"];
            this.street = _data["street"];
            this.number = _data["number"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.legalStatus = _data["legalStatus"];
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(Contact.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewCandidate {
        data = typeof data === 'object' ? data : {};
        let result = new NewCandidate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["businessNumber"] = this.businessNumber;
        data["name"] = this.name;
        data["invoiceName"] = this.invoiceName;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["registrationNumber"] = this.registrationNumber;
        data["street"] = this.street;
        data["number"] = this.number;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["country"] = this.country;
        data["legalStatus"] = this.legalStatus;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a new candidate. */
export interface INewCandidate {
    /** The creation date. */
    createdOn?: Date;
    /** The company business number. */
    businessNumber?: string | undefined;
    /** The company name. */
    name?: string | undefined;
    /** The company invoice name. */
    invoiceName?: string | undefined;
    /** The company phone number. */
    phone?: string | undefined;
    /** The company fax number. */
    fax?: string | undefined;
    /** The company vat number. */
    registrationNumber?: string | undefined;
    /** The street name. */
    street?: string | undefined;
    /** The street number. */
    number?: string | undefined;
    /** The zip code. */
    postalCode?: string | undefined;
    /** The city name. */
    city?: string | undefined;
    /** The country code name. */
    country?: string | undefined;
    /** The legal status. */
    legalStatus?: string | undefined;
    /** The company contacts information. */
    contacts?: Contact[] | undefined;
}

/** Represents a fault message. */
export class Message implements IMessage {
    /** Gets or sets the code of the current Message when applicable.
Sometimes we should implement a code for an error following what the business ask. */
    code?: string | undefined;
    /** Gets or sets the subject of the currendt Message. */
    subject?: string | undefined;
    /** Gets or sets the text of the current Message. */
    text?: string | undefined;
    /** Gets or sets the MessageType of the current Message. */
    type?: MessageType;
    /** Gets or sets the MessageCategory of the current Message. */
    category?: MessageCategory;
    /** Used for compatibility with previous version of Egaf. Technical and Business is new way but the previous category was Described and Undescribed!
So a transformation is done Technical == Undescribed, Business == Described. */
    serialisationCategory?: string;
    /** Add the stacktrace to receive the information on the messsage but not persist it (back to
other app. This is only used when we want to log the message. */
    stackTrace?: string | undefined;

    constructor(data?: IMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.subject = _data["subject"];
            this.text = _data["text"];
            this.type = _data["type"];
            this.category = _data["category"];
            this.serialisationCategory = _data["serialisationCategory"];
            this.stackTrace = _data["stackTrace"];
        }
    }

    static fromJS(data: any): Message {
        data = typeof data === 'object' ? data : {};
        let result = new Message();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["subject"] = this.subject;
        data["text"] = this.text;
        data["type"] = this.type;
        data["category"] = this.category;
        data["serialisationCategory"] = this.serialisationCategory;
        data["stackTrace"] = this.stackTrace;
        return data;
    }
}

/** Represents a fault message. */
export interface IMessage {
    /** Gets or sets the code of the current Message when applicable.
Sometimes we should implement a code for an error following what the business ask. */
    code?: string | undefined;
    /** Gets or sets the subject of the currendt Message. */
    subject?: string | undefined;
    /** Gets or sets the text of the current Message. */
    text?: string | undefined;
    /** Gets or sets the MessageType of the current Message. */
    type?: MessageType;
    /** Gets or sets the MessageCategory of the current Message. */
    category?: MessageCategory;
    /** Used for compatibility with previous version of Egaf. Technical and Business is new way but the previous category was Described and Undescribed!
So a transformation is done Technical == Undescribed, Business == Described. */
    serialisationCategory?: string;
    /** Add the stacktrace to receive the information on the messsage but not persist it (back to
other app. This is only used when we want to log the message. */
    stackTrace?: string | undefined;
}

/** Specifies the different types of a Message. */
export enum MessageType {
    Information = "Information",
    Warning = "Warning",
    Error = "Error",
    Critical = "Critical",
}

/** Specifies the different categories of a Message. */
export enum MessageCategory {
    Technical = "Technical",
    Business = "Business",
}

export class EnvironmentInfo implements IEnvironmentInfo {
    name?: string | undefined;
    server?: string | undefined;
    databaseInfo?: DatabaseInfo[] | undefined;

    constructor(data?: IEnvironmentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.server = _data["server"];
            if (Array.isArray(_data["databaseInfo"])) {
                this.databaseInfo = [] as any;
                for (let item of _data["databaseInfo"])
                    this.databaseInfo!.push(DatabaseInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnvironmentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new EnvironmentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["server"] = this.server;
        if (Array.isArray(this.databaseInfo)) {
            data["databaseInfo"] = [];
            for (let item of this.databaseInfo)
                data["databaseInfo"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEnvironmentInfo {
    name?: string | undefined;
    server?: string | undefined;
    databaseInfo?: DatabaseInfo[] | undefined;
}

export class DatabaseInfo implements IDatabaseInfo {
    server?: string | undefined;
    database?: string | undefined;

    constructor(data?: IDatabaseInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.server = _data["server"];
            this.database = _data["database"];
        }
    }

    static fromJS(data: any): DatabaseInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DatabaseInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["server"] = this.server;
        data["database"] = this.database;
        return data;
    }
}

export interface IDatabaseInfo {
    server?: string | undefined;
    database?: string | undefined;
}

/** Represents a supported country by the application. */
export class Country implements ICountry {
    /** The unique identifier of the country. */
    id?: string | undefined;
    /** The country code. */
    code?: string | undefined;
    /** The country name (translated into the user language). */
    name?: string | undefined;

    constructor(data?: ICountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Country {
        data = typeof data === 'object' ? data : {};
        let result = new Country();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

/** Represents a supported country by the application. */
export interface ICountry {
    /** The unique identifier of the country. */
    id?: string | undefined;
    /** The country code. */
    code?: string | undefined;
    /** The country name (translated into the user language). */
    name?: string | undefined;
}

/** Represents a competence that needs to be covered by a contact. */
export class Competence implements ICompetence {
    /** The unique identifier of the competence. */
    id?: string | undefined;
    /** The unique competence code. */
    code?: string | undefined;
    /** The competence label aka short description. */
    label?: string | undefined;
    /** The competence long description. */
    description?: string | undefined;

    constructor(data?: ICompetence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.label = _data["label"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): Competence {
        data = typeof data === 'object' ? data : {};
        let result = new Competence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["label"] = this.label;
        data["description"] = this.description;
        return data;
    }
}

/** Represents a competence that needs to be covered by a contact. */
export interface ICompetence {
    /** The unique identifier of the competence. */
    id?: string | undefined;
    /** The unique competence code. */
    code?: string | undefined;
    /** The competence label aka short description. */
    label?: string | undefined;
    /** The competence long description. */
    description?: string | undefined;
}

/** Represents a supported language by the application. */
export class Language implements ILanguage {
    /** The language code. */
    code?: string | undefined;
    /** The language name (translated into the user language). */
    name?: string | undefined;

    constructor(data?: ILanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Language {
        data = typeof data === 'object' ? data : {};
        let result = new Language();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

/** Represents a supported language by the application. */
export interface ILanguage {
    /** The language code. */
    code?: string | undefined;
    /** The language name (translated into the user language). */
    name?: string | undefined;
}

/** Represents a supported currency by the application. */
export class Currency implements ICurrency {
    /** The currency symbol. */
    symbol?: string | undefined;
    /** The currency ISO symbol . */
    symbolIso?: string | undefined;
    /** The localized currency name. */
    name?: string | undefined;

    constructor(data?: ICurrency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.symbol = _data["symbol"];
            this.symbolIso = _data["symbolIso"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Currency {
        data = typeof data === 'object' ? data : {};
        let result = new Currency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["symbol"] = this.symbol;
        data["symbolIso"] = this.symbolIso;
        data["name"] = this.name;
        return data;
    }
}

/** Represents a supported currency by the application. */
export interface ICurrency {
    /** The currency symbol. */
    symbol?: string | undefined;
    /** The currency ISO symbol . */
    symbolIso?: string | undefined;
    /** The localized currency name. */
    name?: string | undefined;
}

/** Represents a person title, Mr, Mrs, Miss, etc.... */
export class PersonTitle implements IPersonTitle {
    /** Gets or sets the code to uniquely identify the title. */
    code?: string | undefined;
    /** Gets or sets the long title description. */
    title?: string | undefined;
    /** Gets or sets the short title description. */
    shortTitle?: string | undefined;

    constructor(data?: IPersonTitle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.title = _data["title"];
            this.shortTitle = _data["shortTitle"];
        }
    }

    static fromJS(data: any): PersonTitle {
        data = typeof data === 'object' ? data : {};
        let result = new PersonTitle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["title"] = this.title;
        data["shortTitle"] = this.shortTitle;
        return data;
    }
}

/** Represents a person title, Mr, Mrs, Miss, etc.... */
export interface IPersonTitle {
    /** Gets or sets the code to uniquely identify the title. */
    code?: string | undefined;
    /** Gets or sets the long title description. */
    title?: string | undefined;
    /** Gets or sets the short title description. */
    shortTitle?: string | undefined;
}

/** Represents a competence that needs to be covered by a contact. */
export class LegalStatus implements ILegalStatus {
    /** The unique identifier of the legal status. */
    id?: string | undefined;
    /** The unique legal status code. */
    code?: string | undefined;
    /** The acronym for the legal status. */
    acronym?: string | undefined;
    /** The label for the legal status. */
    label?: string | undefined;
    /** Id of the country for legal status */
    countryId?: string | undefined;

    constructor(data?: ILegalStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.acronym = _data["acronym"];
            this.label = _data["label"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): LegalStatus {
        data = typeof data === 'object' ? data : {};
        let result = new LegalStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["acronym"] = this.acronym;
        data["label"] = this.label;
        data["countryId"] = this.countryId;
        return data;
    }
}

/** Represents a competence that needs to be covered by a contact. */
export interface ILegalStatus {
    /** The unique identifier of the legal status. */
    id?: string | undefined;
    /** The unique legal status code. */
    code?: string | undefined;
    /** The acronym for the legal status. */
    acronym?: string | undefined;
    /** The label for the legal status. */
    label?: string | undefined;
    /** Id of the country for legal status */
    countryId?: string | undefined;
}

export class Option implements IOption {
    id?: string | undefined;
    code?: string | undefined;
    name?: string | undefined;
    hint?: string | undefined;
    category?: string | undefined;
    tags?: string[] | undefined;

    constructor(data?: IOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.hint = _data["hint"];
            this.category = _data["category"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): Option {
        data = typeof data === 'object' ? data : {};
        let result = new Option();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["hint"] = this.hint;
        data["category"] = this.category;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface IOption {
    id?: string | undefined;
    code?: string | undefined;
    name?: string | undefined;
    hint?: string | undefined;
    category?: string | undefined;
    tags?: string[] | undefined;
}

export class MailingOptions implements IMailingOptions {
    fromAddress?: string | undefined;
    itAddresses?: string[] | undefined;
    businessAddresses?: string[] | undefined;

    constructor(data?: IMailingOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromAddress = _data["fromAddress"];
            if (Array.isArray(_data["itAddresses"])) {
                this.itAddresses = [] as any;
                for (let item of _data["itAddresses"])
                    this.itAddresses!.push(item);
            }
            if (Array.isArray(_data["businessAddresses"])) {
                this.businessAddresses = [] as any;
                for (let item of _data["businessAddresses"])
                    this.businessAddresses!.push(item);
            }
        }
    }

    static fromJS(data: any): MailingOptions {
        data = typeof data === 'object' ? data : {};
        let result = new MailingOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromAddress"] = this.fromAddress;
        if (Array.isArray(this.itAddresses)) {
            data["itAddresses"] = [];
            for (let item of this.itAddresses)
                data["itAddresses"].push(item);
        }
        if (Array.isArray(this.businessAddresses)) {
            data["businessAddresses"] = [];
            for (let item of this.businessAddresses)
                data["businessAddresses"].push(item);
        }
        return data;
    }
}

export interface IMailingOptions {
    fromAddress?: string | undefined;
    itAddresses?: string[] | undefined;
    businessAddresses?: string[] | undefined;
}

export class EmailMessage implements IEmailMessage {
    candidateId?: string | undefined;
    candidateName?: string | undefined;
    code?: string | undefined;
    language?: string | undefined;
    to?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;

    constructor(data?: IEmailMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidateId = _data["candidateId"];
            this.candidateName = _data["candidateName"];
            this.code = _data["code"];
            this.language = _data["language"];
            this.to = _data["to"];
            this.cc = _data["cc"];
            this.bcc = _data["bcc"];
            this.subject = _data["subject"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): EmailMessage {
        data = typeof data === 'object' ? data : {};
        let result = new EmailMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidateId"] = this.candidateId;
        data["candidateName"] = this.candidateName;
        data["code"] = this.code;
        data["language"] = this.language;
        data["to"] = this.to;
        data["cc"] = this.cc;
        data["bcc"] = this.bcc;
        data["subject"] = this.subject;
        data["body"] = this.body;
        return data;
    }
}

export interface IEmailMessage {
    candidateId?: string | undefined;
    candidateName?: string | undefined;
    code?: string | undefined;
    language?: string | undefined;
    to?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
}

export class Setting implements ISetting {
    id?: string | undefined;
    type?: SettingType;
    value?: string | undefined;
    isVisible?: boolean;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.value = _data["value"];
            this.isVisible = _data["isVisible"];
        }
    }

    static fromJS(data: any): Setting {
        data = typeof data === 'object' ? data : {};
        let result = new Setting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["value"] = this.value;
        data["isVisible"] = this.isVisible;
        return data;
    }
}

export interface ISetting {
    id?: string | undefined;
    type?: SettingType;
    value?: string | undefined;
    isVisible?: boolean;
}

export enum SettingType {
    None = "None",
    Disclaimer = "Disclaimer",
}

export class Validator implements IValidator {
    id?: string | undefined;
    name?: string | undefined;
    isActive?: boolean;

    constructor(data?: IValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): Validator {
        data = typeof data === 'object' ? data : {};
        let result = new Validator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IValidator {
    id?: string | undefined;
    name?: string | undefined;
    isActive?: boolean;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

require('es6-promise').polyfill();
require('isomorphic-fetch');